import { render, staticRenderFns } from "./GerenciamentoLoginSocial.vue?vue&type=template&id=e7988c06&scoped=true"
import script from "./GerenciamentoLoginSocial.vue?vue&type=script&lang=js"
export * from "./GerenciamentoLoginSocial.vue?vue&type=script&lang=js"
import style0 from "./GerenciamentoLoginSocial.vue?vue&type=style&index=0&id=e7988c06&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7988c06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7988c06')) {
      api.createRecord('e7988c06', component.options)
    } else {
      api.reload('e7988c06', component.options)
    }
    module.hot.accept("./GerenciamentoLoginSocial.vue?vue&type=template&id=e7988c06&scoped=true", function () {
      api.rerender('e7988c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GerenciamentoLoginSocial.vue"
export default component.exports